import { type ReactElement, useEffect } from 'react'
import type { InputInFormProps } from '~/components/Form/Input/input'
import { Toggle } from '~/components/Global/Interactions/Toggle/Toggle'

type ToggleInputProps = {
  name?: string
  label?: string
  onChange?: (checked: boolean) => void
} & InputInFormProps

export const ToggleInput = ({
  name,
  label,
  register,
  watch,
  setValue,
  onChange
}: ToggleInputProps): ReactElement => {
  if (!register || !name || !setValue) {
    throw new Error(
      'ToggleInput must be used inside a Form component or provide standalone prop'
    )
  }

  const currentValue = watch && name ? watch(name) : false

  useEffect(() => {
    register(name)
    if (currentValue === undefined) {
      setValue(name, false, { shouldDirty: false })
    }
  }, [register, name, setValue, currentValue])

  const handleChange = (checked: boolean) => {
    onChange?.(checked)
    setValue(name, checked, { shouldDirty: true, shouldValidate: true })
  }

  return (
    <Toggle
      key={`${name}-${currentValue}`}
      defaultState={currentValue ?? false}
      onChange={handleChange}
      label={label}
    />
  )
}
